module.exports = __webpack_public_path__ + "img/icon_green.e944734b.svg";